module.exports = __webpack_public_path__ + "static/media/big-small-mobile-section.38a89286.png";